import PropTypes from 'prop-types';

// material-ui
import { useMediaQuery, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// assets
import CloseIcon from '@mui/icons-material/Close';

// ===============================|| Dialog ||=============================== //

const FormDialog = ({ fullScreen, maxWidth, onClose, children }) => {
    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={maxWidth || 'xs'}
            fullWidth={true}
            fullScreen={fullScreen == undefined ? (window.innerWidth <= 800 ? true : false) : fullScreen}
        >
            <DialogTitle sx={{ m: 0, p: 2 }}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        left: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions></DialogActions>
        </Dialog>
    );
};

FormDialog.propTypes = {
    fullScreen: PropTypes.bool,
    maxWidth: PropTypes.string,
    onClose: PropTypes.func
};

export default FormDialog;
